<template lang="html">
  <div
    :class="{ 'h-screen': $attrs.groupData.event != 'live' }"
    class="event relative text-white"
  >
    <span
      v-if="$attrs.groupData.event === 'live'"
      class="bg-white border shadow p-2 text-black m-1 absolute right-0 top-0"
      >{{ $attrs.counter }}</span
    >
    <div class="text-center flex pb-4">
      <span class="w-1/2"
        >Welcome to <strong>{{ $attrs.groupData.group }}</strong></span
      >
      <span class="text-center w-1/2 block font-semibold"
        >ID # {{ $attrs.groupID }}</span
      >
    </div>
    <Header v-if="$attrs.groupData.event != 'live'" />
    <div
      v-if="$attrs.groupData.event != 'live'"
      class="text-center block mt-16 w-full"
    >
      <span
        >This event is yet to begin! <br />
        thanks for your patience...</span
      >
      <span class="block">
        <i class="far text-3xl m-4 fa-clock"></i>
      </span>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header/Logo.vue";
export default {
  components: {
    Header
  }
};
</script>
